// eslint-disable-next-line typescript-enum/no-enum
export enum Modals {
  language = 'language',
  contentViewingPrefs = 'content_viewing_prefs',
}
